// extracted by mini-css-extract-plugin
module.exports = {"container":"cornerQuantity_container__9d1wn","content":"cornerQuantity_content__JoaxK","loader":"cornerQuantity_loader__ME6_w"};